(function stickyButton () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "sticky-button";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {

      const stickyButton = document.querySelector('.sticky-button');
      const stickyButtonDataValue = stickyButton.getAttribute('data-widget-to-stiky');
      const widgetTostikyDataId =  stickyButtonDataValue ?? "widget-simu-button";
      const widgetSimuButton = document.querySelector('#'+widgetTostikyDataId);
      const btnSimulate = document.querySelector('#sticky-simu-btn');


            let isMobile = window.matchMedia("(max-width: 830px)");
      let observer;

      const displayStickyButton = (element) => {
        element.style.display = 'flex';
        element.style.opacity = '1';
      }

      const watchObserverAndModifyButtonStyle = (entries) => {
        entries.forEach(entry => {
          if (!isMobile.matches) {
            if (entry.isIntersecting) {
              stickyButton.style.opacity = '0';
              setTimeout(() => {
                  stickyButton.style.display = 'none';
              }, 300);
            } else {
              stickyButton.style.display = 'flex';
              setTimeout(() => {
                  stickyButton.style.opacity = '1';
              }, 300);
            } 
          } else {
            displayStickyButton(stickyButton);
          }
        }); 
      }

      const observeWidgetButton = () => {
        observer = new IntersectionObserver(watchObserverAndModifyButtonStyle);
        widgetSimuButton ? observer.observe(widgetSimuButton) : displayStickyButton(stickyButton);
      }

      observeWidgetButton();

      isMobile.addEventListener('change', observeWidgetButton);

      const getCodeVendeurFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('codevendeur'); 
      };
      const getOriginMobileFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('originMobile'); 
      };

    btnSimulate.addEventListener('click', (e) => {
        e.preventDefault();

        const baseHref = btnSimulate.href; 


        const codeVendeur = getCodeVendeurFromUrl();

        const originMobile = getOriginMobileFromUrl();

        const paramsToAdd = [];

        if (codeVendeur) {
          paramsToAdd.push(`codevendeur=${encodeURIComponent(codeVendeur)}`);
        }

        if (originMobile) {
          paramsToAdd.push(`originMobile=${encodeURIComponent(originMobile)}`);
        }

        const separator = baseHref.includes('?') ? '&' : '?';

        const redirectTo = paramsToAdd.length
          ? `${baseHref}${separator}${paramsToAdd.join('&')}`
          : baseHref; 

        window.location.replace(redirectTo);
      });

    });
})()